import React from "react";
import { Link } from "react-router-dom";
import { Jumbotron } from "./migration";
import ExperienceCard from "./ExperienceCard";

const Experience = ({ heading, data, limit, viewAllHref }) => {
  const items = limit ? data.slice(0, limit) : data;

  return (
    <Jumbotron id="experience" className="m-0">
      <div className="d-flex justify-content-between align-items-baseline mb-4">
        <h2 className="section-heading">{heading}</h2>
        {viewAllHref && (
          <Link className="text-link" to={viewAllHref}>
            View all
          </Link>
        )}
      </div>
      {items.map((item, index) => (
        <ExperienceCard key={`experience-${index}`} data={item} />
      ))}
    </Jumbotron>
  );
};

export default Experience;
